import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const billingRoutes: Routes = [
  {
    path: 'billing',
    children: [
      {
        path: 'bills',
        loadComponent: () => import('./bills/list-bills/list-bills').then((c) => c.ListBills),
      },
      {
        path: 'service-fee-configurations',
        loadComponent: () =>
          import(
            './service-fee-configurations/list-service-fee-configurations/list-service-fee-configurations'
          ).then((c) => c.ListServiceFeeConfigurations),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILL_SERVICE_FEE_CONFIG_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'service-fee-configurations/add',
        loadComponent: () =>
          import(
            './service-fee-configurations/dialogs/service-fee-configuration-dialog.component'
          ).then((c) => c.ServiceFeeConfigurationDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILL_SERVICE_FEE_CONFIG_ADD'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'service-fee-configurations/edit/:uuid',
        loadComponent: () =>
          import(
            './service-fee-configurations/dialogs/service-fee-configuration-dialog.component'
          ).then((c) => c.ServiceFeeConfigurationDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILL_SERVICE_FEE_CONFIG_EDIT'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'service-providers',
        loadComponent: () =>
          import(
            './service-providers/list-service-providers/list-service-providers'
          ).then((c) => c.ListServiceProviders),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILLING_SERVICE_PROVIDER_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'manual-bills',
        loadComponent: () =>
          import('./bills/list-manual-bills/list-manual-bills').then((c) => c.ListManualBills),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_FINANCE_MANUAL_BILL_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'manual-bills/add',
        loadComponent: () =>
          import('./bills/list-manual-bills/dialogs/save-manual-bill-dialog.component').then(
            (c) => c.SaveManualBillDialogComponent
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_FINANCE_MANUAL_BILL_ADD'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'manual-bills/edit/:uuid',
        loadComponent: () =>
          import('./bills/list-manual-bills/dialogs/save-manual-bill-dialog.component').then(
            (c) => c.SaveManualBillDialogComponent
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_FINANCE_MANUAL_BILL_EDIT'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'manual-bills/:id',
        loadComponent: () =>
          import('./bills/list-manual-bills/detail/manual-bill-details.component').then(
            (c) => c.ManualBillDetailsComponent
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_FINANCE_MANUAL_BILL_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'receipts',
        loadComponent: () =>
          import('./receipts/list-receipts/list-receipts').then((c) => c.ListReceipts),
      },
      {
        path: 'reconciliations',
        loadComponent: () =>
          import('./reconciliations/list-reconciliations/list-reconciliations').then(
            (c) => c.ListReconciliations
          ),
      },
      {
        path: 'reconciliations/:uuid',
        loadComponent: () =>
          import('./reconciliations/detail/reconciliation-details.component').then(
            (c) => c.ReconciliationDetailsComponent
          ),
      },
      {
        path: 'bill-change-requests',
        loadComponent: () =>
          import('./bills/bill-change-requests/bill-change-requests.component').then(
            (c) => c.BillChangeRequestsComponent
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILLING_BILL_CHANGE_VIEW', 'ROLE_BILLING_BILLS_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'bill-change-requests/:uuid',
        loadComponent: () =>
          import(
            './bills/bill-change-requests/detail/bill-change-request-details.component'
          ).then((c) => c.BillChangeRequestDetailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_BILLING_BILL_CHANGE_VIEW', 'ROLE_BILLING_BILLS_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },

      {
        path: 'historical-depts',
        loadComponent: () =>
          import('./historical-depts/list-historical-depts/list-historical-depts').then(
            (c) => c.ListHistoricalDepts
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'historical-depts/add',
        loadComponent: () =>
          import(
            './historical-depts/dialogs/save-historical-dept-dialog.component'
          ).then((c) => c.SaveHistoricalDeptDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_CREATE'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'historical-depts/edit/:uuid',
        loadComponent: () =>
          import(
            './historical-depts/dialogs/save-historical-dept-dialog.component'
          ).then((c) => c.SaveHistoricalDeptDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_UPDATE'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'historical-depts/:uuid',
        loadComponent: () =>
          import(
            './historical-depts/detail/historical-dept-details.component'
          ).then((c) => c.HistoricalDeptDetailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'dept-payments',
        loadComponent: () =>
          import('./dept-payments/list-dept-payments/list-dept-payments').then(
            (c) => c.ListDeptPayments
          ),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'dept-payments/add',
        loadComponent: () =>
          import(
            './dept-payments/dialogs/save-dept-payment-dialog.component'
          ).then((c) => c.SaveDeptPaymentDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_CREATE'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'dept-payments/edit/:uuid',
        loadComponent: () =>
          import(
            './dept-payments/dialogs/save-dept-payment-dialog.component'
          ).then((c) => c.SaveDeptPaymentDialogComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_UPDATE'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'dept-payments/:uuid',
        loadComponent: () =>
          import(
            './dept-payments/detail/dept-payment-details.component'
          ).then((c) => c.DeptPaymentDetailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['ROLE_HISTORICAL_DEPT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE,
          },
        },
      },
      {
        path: 'bills/:uuid',
        loadComponent: () => import('./bills/bill-details/bill-details').then((c) => c.BillDetails),
      },
    ],
  },
];
